import { render, staticRenderFns } from "./plusminus.vue?vue&type=template&id=d877769a&"
import script from "./plusminus.vue?vue&type=script&lang=js&"
export * from "./plusminus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports